<template>
    <small class="error" v-if="shouldShowError(fieldName)">
        {{errors.first(fieldName)}}
    </small>
</template>
<script>
export default {
    name: 'Error',
    inject: ['$validator'],
    props: ['fieldName'],
    methods: {
        shouldShowError (fieldName) {
            return undefined !== this.errors.first(fieldName)
        }
    }
}
</script>

<style scoped>
.error {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #ed1c24;
    border-radius: 5px;
    background-color: rgba(237,28,36,.2);
    padding: 8px 12px;
    margin: 3px 0 0;
}
</style>
